import styled from "@emotion/styled";
import { Box } from "@otrium/core";

const Wrapper = styled(Box)<{ borderColor?: string }>`
  align-items: center;
  ${({ borderColor }) =>
    borderColor && `border-bottom: solid 1px ${borderColor};`}
  display: flex;
  letter-spacing: normal;
  line-height: 25px;
`;

const RightAdornment = styled.div`
  margin-left: auto;
`;

export { Wrapper, RightAdornment };
